<template>
    <div class="store-card-container">
        <div class="card" style="width: 18rem;" v-for="(store, index) in stores">
            <img :src="'https://picsum.photos/200/100/?blur=2&random=' + index" alt="Default Image"
                 class="card-img-top">
            <div class="card-body">
                <h5 class="card-title">{{ store.company_name }} - {{ store.name }} <span
                    v-if="typeof store.distance !== 'undefined'">({{ store.distance }} miles)</span></h5>
                <p class="card-sub-title small">{{ store.stands }} Stands Available</p>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <a :href="storeUrl + '/' + store.id" class="btn btn-primary w-100">Find Availability</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        name: "MappedStores",

        props: {
            storeData: {
                type: Array | Object
            },
            storeUrl: {
                type: String
            }
        },

        data() {
            return {
                stores: [],
            };
        },

        watch: {
            storeData: function () {
                this.stores = this.storeData;
            }
        },

        mounted() {
            //
        },

        methods: {
            //
        }
    };
</script>
